import { MantineTheme } from "@mantine/core";
import { Component, ComponentModelDefinition, Editor } from "grapesjs";
import { renderToStaticMarkup } from "react-dom/server";

export const HL_BASE_COMPONENT_TYPE = "hl-base-component";

/* eslint-disable @typescript-eslint/no-explicit-any */
type Props = any;

export const ViewComponent = (
  props: Props & {
    theme: MantineTheme;
    that: ComponentModelDefinition & Component;
  }
) => {
  const { that, ...rest } = props;

  return (
    <div>
      {that.get("type")}
      <pre>{rest}</pre>
    </div>
  );
};

export const BaseHLComponentPlugin =
  (theme: MantineTheme) => (editor: Editor) => {
    const { Components } = editor;

    Components.addType(HL_BASE_COMPONENT_TYPE, {
      isComponent() {
        // No need to check since the element needs
        // to have the data-gjs-type attribute
        return false;
      },
      extend: "default",
      extendFn: ["init", "updated"],
      model: {
        defaults: {
          type: HL_BASE_COMPONENT_TYPE,
          name: "HL base component",
          tagName: "div",
          droppable: false,
          resizable: false,
          editable: false,
          attributes: {
            "data-gjs-type": HL_BASE_COMPONENT_TYPE,
          },
          traits: [],
          stylable: [],
        },

        init() {
          console.log("BaseHLComponentPlugin [init]", this);
        },
        // Used to store JSON data as a child
        toJSONData(): Props {
          const traits = this.getTraits().reduce((acc, trait) => {
            const name =
              trait.get("name") ?? trait.get("id") ?? "unknown-trait";
            const value = trait.get("value");
            acc[name] = value;
            return acc;
            /* eslint-disable @typescript-eslint/no-explicit-any */
          }, {} as Record<string, any>);

          return traits;
        },
        toHTML() {
          return renderToStaticMarkup(
            <div
              data-gjs-type={this.get("type")}
              dangerouslySetInnerHTML={{
                __html: JSON.stringify(this.toJSONData()),
              }}
            ></div>
          );
        },
        updated(property) {
          const watchedProperties = this.getTraits().map((trait) =>
            trait.get("name")
          );
          if (watchedProperties.includes(property)) {
            this.view?.render();
          }
        },
      },

      // Used to display the "fake" component in the canvas
      view: {
        onRender({ el, model }) {
          console.log("BaseHLComponent [onRender]", { el, model });
          //@ts-ignore
          const props = this.model.toJSONData();
          el.innerHTML = renderToStaticMarkup(
            <ViewComponent {...props} theme={theme} />
          );
        },
      },
    });
  };
